import AccountsMixin from "./AccountsMixin.vue";
import { EVENTS } from "@/utils";
import InitializeFiltersMixin from "./InitializeFiltersMixin.vue";
import { mapState } from "vuex";
export default {
  name: "ProfitAndLossMixin",
  mixins: [AccountsMixin, InitializeFiltersMixin],
  computed: {
    ...mapState({
      products: state => state.profitAndLoss.products,
      sellers: state => state.profitAndLoss.sellers,
      marketplaces: state => state.profitAndLoss.marketplaces
    })
  },
  methods: {
    async getFilterValuesForSellersFilter() {
      let sellers = await this.getOmnyAccountSellers();
      return sellers;
    },
    async getFilterValuesForMarketPlacesFilter() {
      const path = `/profit_and_loss/filters/countries`;
      const marketplaces = await this.getCountriesBasedOnSellers({
        sellers: this.sellers_filter.filterValues
      }, path);
      console.log("Marketplaces ", marketplaces);
      return marketplaces;
    }
  }
};